import { useState } from "react";
import Header from "../components/header/Header";
import SideMenu, { MenuItem } from "../components/side-menu/SideMenu";
import { Box } from "@mui/material";
import MainPage from "./MainPage";
import styles from "../pages/Styles/AppLayout.module.scss";
import { NavigationMenuContextProvider } from '../../store/side-menu-navigation-context'
import SessionTimeout from "../components/SessionTimeout/SessionTimeout";

export default function AppLayout() {
  const defaultMenu: MenuItem = { title: "Overview", color: "", path: "REST APIs/Guides" }

  const [menu, setMenuItem] = useState<MenuItem>(defaultMenu);
  const [activeItem, setActiveItem] = useState<{ item: MenuItem } | undefined>({ item: { title: "Overview", color: "", path: "REST APIs/Guides" } });
  const [breadCrumbConfig, setBreadCrumbConfig] = useState<string[]>([]);

  const onMenuClick = (item: MenuItem) => {
    setActiveItem({ item });
    setMenuItem(item);
  };

  return (
    <NavigationMenuContextProvider>
      <div className={styles.headerHeight}>
        <Box>
          <Header onMenuClick={onMenuClick} />
        </Box>
      </div>

      <div className={styles.content}>
        <SideMenu onMenuClick={onMenuClick} activeItem={activeItem} menu={menu} breadCrumbConfig={breadCrumbConfig}></SideMenu>
        <MainPage
          menu={menu}
          setBreadCrumbConfig={setBreadCrumbConfig}
          activeItem={activeItem}></MainPage>
      </div>
      <SessionTimeout/>
    </NavigationMenuContextProvider>
  );
}
